import { Button, CircularProgress } from '@mui/material';
import Typography from '@mui/material/Typography';
import AuthLayout from './AuthLayout';
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import EmailIcon from '@mui/icons-material/Email';
import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import Alert from '@mui/material/Alert';

const ResetPasswordEmail = () => {
   const [error, setError] = useState('');
   const navigate = useNavigate();
   const [loading, setLoading] = useState(false);
   const [email, setEmail] = useState('');

   const handleSubmit = async () => {
      try {
         setLoading(true);

         const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/forgot-password`, {
            method: 'POST',
            body: JSON.stringify({ email }),
            headers: {
               'Content-Type': 'application/json',
            },
         });

         const data = await response.json();

         if (data.status == 400) {
            setError(data.message);
            return;
         }
      } catch (error: any) {
         setError(error.message);
      } finally {
         setTimeout(() => {
            setError('');
         }, 5000);
         setLoading(false);
         setEmail('');
      }
   };

   return (
      <AuthLayout>
         {error && (
            <Alert sx={{ mb: 2 }} severity='error'>
               {error}
            </Alert>
         )}
         <Typography variant='h4' color='primary'>
            Reset Password
         </Typography>
         <Typography variant='body1' sx={{ mb: 4 }} color='text.secondary'>
            Please enter the email address you used when you joined and we’ll send you instructions
            to reset your password.
         </Typography>

         <Grid container spacing={2}>
            <Grid item xs={12}>
               <TextField
                  fullWidth
                  label='Email Address'
                  type='email'
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={loading}
                  InputProps={{
                     startAdornment: (
                        <InputAdornment position='start'>
                           <EmailIcon color='primary' />
                        </InputAdornment>
                     ),
                  }}
                  required
               />
            </Grid>
            <Grid
               item
               xs={12}
               sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  flexDirection: 'column',
                  alignItems: 'center',
                  gap: 2,
               }}
            >
               <Button
                  onClick={handleSubmit}
                  fullWidth
                  variant='contained'
                  color='primary'
                  disabled={loading}
                  sx={{
                     display: 'flex',
                     justifyContent: 'center',
                     alignItems: 'center',
                     gap: 2,
                  }}
               >
                  Send Reset Link {loading && <CircularProgress size={20} />}
               </Button>
               <Button
                  fullWidth
                  // variant='contained'
                  color='inherit'
                  onClick={() => navigate('/login')}
               >
                  Back to Login
               </Button>
            </Grid>
         </Grid>
      </AuthLayout>
   );
};

export default ResetPasswordEmail;
